document.addEventListener("DOMContentLoaded", function () {
    const nameField = document.querySelector(".contactFormText");
    const emailField = document.querySelector(".contactFormEmail");
    const phoneField = document.querySelector(".contactFormPhone");
    const CheckboxFeild = document.querySelector(".contactFormCheckbox");
    const errorFields = {
        name: document.querySelector(".name-error"),
        email: document.querySelector(".email-error"),
        phone: document.querySelector(".phone-error"),
        concern: document.querySelector(".concern-error"),
        submit: document.querySelector(".submit-error"),
        checkbox: document.querySelector(".checkbox-error")
    };

function showError(field, message) {
    field.textContent = message;
    field.classList.add("error");
}


function clearError(field) {
    field.textContent = "";
    field.classList.remove("error");
}

    function nameCheck() {
        const nameValue = nameField.value.trim();
        errorFields.name.textContent = "";

        if (!nameValue) {
            showError(errorFields.name, "Name field cannot be empty!");
            return false;
        }

        if (/\d/.test(nameValue)) {
            nameField.value = nameValue.replace(/\d/g, '');
            return false;
        }
        clearError(errorFields.name);
        return true;
    }

    function emailCheck() {
        const emailValue = emailField.value.trim();
        errorFields.email.textContent = "";

        if (!emailValue) {
            showError(errorFields.email, "Email field cannot be empty!");
            return false;
        }

        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(emailValue)) {
            showError(errorFields.email, "Please enter a valid email address!");
            return false;
        }
        clearError(errorFields.email);
        return true;
    }

    function phoneCheck() {
        const phoneValue = phoneField.value.trim();
        errorFields.phone.textContent = "";

        if (!phoneValue) {
            showError(errorFields.phone, "Phone number cannot be empty!");
            return false;
        }

        if (phoneValue.startsWith("+91")) {
            showError(errorFields.phone, "Phone number should not start with +91!");
            return false;
        }

        const phonePattern = /^[6-9]\d{9}$/;
        if (!phonePattern.test(phoneValue)) {
            showError(errorFields.phone, "Enter a valid 10-digit Indian phone number!");
            return false;
        }
        clearError(errorFields.phone);
        return true;
    }

    function checkSelectedConcern() {
        const selectedButtons = document.querySelectorAll(".concern-btn.selected");

        if (selectedButtons.length === 0) {
            showError(errorFields.concern, "Please select at least one concern!");
            return false;
        }

        clearError(errorFields.concern);
        return true;
    }

    function checkConsentForm(){
        const consentCheckbox = document.querySelector(".contactFormCheckbox");

        if (!consentCheckbox.checked){
            showError(errorFields.checkbox, "Plese check the checkbox!");
            return false;
        }
        else{
            clearError(errorFields.checkbox);
            return true;
        }
    }

    // Event delegation for concern button selection
    document.querySelector(".concern-container").addEventListener("click", function (e) {
        e.preventDefault();
        if (e.target.classList.contains("concern-btn")) {
            e.target.classList.toggle("selected");
            checkSelectedConcern();
        }
    });

    nameField.addEventListener("input", nameCheck);
    nameField.addEventListener("blur", nameCheck);
    emailField.addEventListener("input", emailCheck);
    emailField.addEventListener("blur", emailCheck);
    phoneField.addEventListener("input", phoneCheck);
    phoneField.addEventListener("blur", phoneCheck);

    document.querySelector(".submitContactForm").addEventListener("click", function (e) {
        e.preventDefault();
        errorFields.submit.textContent = "";

        let isValid = nameCheck() & emailCheck() & phoneCheck() & checkSelectedConcern();

        if (isValid) {
            this.setAttribute('disabled', 'disabled');
            this.classList.add('disabled');
            document.body.style.overflow = "hidden";
            // set duedate i.e 50 days from today as a payload.
            let today = new Date();
            today.setDate(today.getDate() + 50);
            let dueDate = today.toISOString().split("T")[0]; // Formats as YYYY-MM-DD

            // Get all selected buttons from concern and join their values with commas
            const selectedBtns = document.querySelectorAll('.concern-btn.selected');
            const btnValues = Array.from(selectedBtns).map(btn => btn.textContent).join(", ");
            const firstBtnValue = selectedBtns.length > 0 ? selectedBtns[0].textContent : "";

            // Collect form data
            let requestData = {
                title: firstBtnValue,
                ticket_details: document.querySelector('[name="contact[body]"]').value,
                due_date: dueDate,
                customer_name: document.querySelector('[name="contact[name]"]').value,
                phone: document.querySelector('[name="contact[telephone]"]').value,
                email_id: document.querySelector('[name="contact[email]"]').value,
                faqs: [{
                    select_your_concern: btnValues,
                    your_message: document.querySelector('[name="contact[body]"]').value,
                }]
            };

            // Send the request
            fetch(APIBASEURL + "/whatsapp_integration/customerTickets.php", {
                method: "POST",
                body: JSON.stringify([requestData]) // Send as an array
            })
                .then(response => response.json())
                .then(data => {
                    console.log(data);
                    document.querySelector('#successModal').style.display = "block";
                        setTimeout(() => {                            
                        location.reload();
                    }, 2000);
                    // once the gigya is working fine uncomment the below line and remove the above 4 lines
                    // const consentcheckbox = document.querySelector('.contactFormCheckbox');
                    // if (consentcheckbox.checked) {
                    //     const phone = requestData.phone;
                    //     const email = requestData.email_id;
                    //     const name = requestData.customer_name;
                    //     updateGigya(phone,email,name);
                    // } else {
                    //     document.querySelector('#successModal').style.display = "block";
                    //     setTimeout(() => {                            
                    //     location.reload();
                    //     }, 2000);
                    // }
                })
                .catch(error => {
                    console.error("Submission failed:", error);
                });
        } else {
            // showError(errorFields.submit, "Please fix the field errors.");
        }
    });
    //close popup when X icon is clicked
    const closecontactModal = document.querySelector('.close-contactModal');
    closecontactModal.addEventListener("click", function () {
        document.querySelector('#successModal').style.display = "none";
        location.reload();
    });
});

function updateGigya(phone, email, name) {
    document.querySelector('#loadingPopup').style.display = "flex";
    var encMobile = btoa(JSON.stringify({ mobile: phone }));
    var gigyaData = JSON.stringify({
        phone: encMobile,
        firstName: name,
        lastName: 'test',
        emailAddress: email
    });

    fetch(APIBASEURL + '/updateCustomerConsent.php', {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: gigyaData
    })
    .then(response => response.json())
    .then(data => {
        const unileverID = data.UnileverId;
        document.cookie = `unileverId=${unileverID}; path=/; max-age=31536000; Secure; SameSite=Strict`; 
        document.querySelector('#loadingPopup').style.display = "none";       
        document.querySelector('#successModal').style.display = "block";
        document.body.style.overflow = "hidden";
        location.reload();
    })
    .catch(error => {
        console.error("Gigya submission failed:", error);
    });
}
